export default __webpack_public_path__ + "static/media/arrow_down_more.a60bf91a.svg";